export default {
  error: state => state.error,
  formLoading: state => state.formLoading,
  success: state => state.success,
  loading: state => state.loading,
  events: state => state.events,
  singleEvent: state => state.singleEvent,
  downloadLink: state => state.downloadLink,
  exportLoading: state => state.exportLoading,
  eventCreated: state => state.eventCreated,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/Calendar/getters.js